import { useParams } from 'react-router';

import { useGetTestingParticipantsQuery } from '@/api/endpoints/schools/schoolSelectionPanel';
import { Loader } from '@/shared/components';
import { ETestStatus } from '@/shared/types';

import { UsersAssignmentPage } from './UsersAssignmentPage';

export const UsersAssignmentPageWrapper = () => {
  const { id: schoolId } = useParams();

  const {
    data: testingData,
    isLoading: isTestingLoading,
    isError: isTestingFetchError,
  } = useGetTestingParticipantsQuery({
    schoolId: Number(schoolId),
    page: 1,
    perPage: 999,
    statusFilter: [ETestStatus.TestPassed, ETestStatus.TestFailed],
  });

  const passedTestingData = testingData?.data.filter((test) => test.status === ETestStatus.TestPassed);
  const failedTestingData = testingData?.data.filter((test) => test.status === ETestStatus.TestFailed);

  if (isTestingLoading) {
    return <Loader isSpinning />;
  }

  if (isTestingFetchError) {
    return <p>Ошибка</p>;
  }

  if (passedTestingData && failedTestingData) {
    return (
      <UsersAssignmentPage
        passedTestingData={passedTestingData}
        failedTestingData={failedTestingData}
      />
    );
  }
};
